module.exports = __webpack_public_path__ + "img/news13-0.c2f055ab.png";